import React from 'react';
import { Link } from 'react-router-dom';
import * as LucideIcons from 'lucide-react';
import { ChevronRight } from 'lucide-react';

const LinkCard = ({ data }) => {
  const Icon = data?.icon ? LucideIcons[data.icon] : null;
  return (
    <Link
      to={data?.route || '/dashboard'}
      className="flex items-center gap-3 rounded-sm border border-zinc-700 bg-zinc-900/40 px-4 py-3 hover:border-primary hover:bg-primary/5 hover:text-primary transition-colors text-sm font-secondary font-bold group"
      data-testid="card-link"
    >
      {Icon && <Icon className="w-4 h-4" />}
      <span className="flex-1">{data?.label || 'Open'}</span>
      <ChevronRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
    </Link>
  );
};

export default LinkCard;
